import { render, staticRenderFns } from "./editor-layer-header.vue?vue&type=template&id=2ec338e2"
import script from "./editor-layer-header.vue?vue&type=script&lang=js"
export * from "./editor-layer-header.vue?vue&type=script&lang=js"
import style0 from "./editor-layer-header.vue?vue&type=style&index=0&id=2ec338e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports